import api from '../api';

// Admin/compras: todos los artículos de Seminuevos (A10012), estén publicados o no.
export async function listArticulosSeminuevos({ token }) {
  const res = await api.get('/catalog/admin/existencias', {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

// Publica un artículo (foto + precio + interés) — formData lleva art_clave.
export async function createCatalogItem({ token, formData }) {
  const res = await api.post('/catalog/items', formData, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

// Público: solo lo publicado, con foto y precio, y con existencia en Seminuevos.
export async function listCatalogItems() {
  const res = await api.get('/catalog/items');
  return res.data;
}

export async function toggleCatalogItem({ id, token }) {
  const res = await api.patch(`/catalog/items/${id}/toggle`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

export async function getCatalogItem(id) {
  const res = await api.get(`/catalog/items/${id}`);
  return res.data;
}

export async function updateCatalogItem({ id, token, title, category, description, price, interesAnual, imagesFiles = [], existingImages = [] }) {
  const fd = new FormData();
  fd.append('title', title);
  fd.append('category', category ?? 'General');
  fd.append('description', description ?? '');
  fd.append('price', price);
  fd.append('interes_anual', interesAnual);
  fd.append('existingImages', JSON.stringify(existingImages));

  imagesFiles.forEach(f => fd.append('images', f));

  const res = await api.put(`/catalog/items/${id}`, fd, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

export async function listCategories() {
  const res = await api.get('/catalog/categories');
  return res.data;
}

export async function deleteCatalogItem({ id, token }) {
  const res = await api.delete(`/catalog/items/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}
